<template>
  <div class="d-flex w-100">
    <div class="d-flex w-100">
      <div class="col-md-3">
        <AprReportPainel @quantitativos="quantitativos" ref="painelAPR"></AprReportPainel>
        <AprReportFiltro @search="search"></AprReportFiltro>
      </div>
      <div class="col-md-9">
        <AprReportTable ref="tableRelatorioAPR"></AprReportTable>
      </div>
    </div>
  </div>
</template>

<script>
import aprReport from './aprReport'
export default aprReport
</script>

<style scoped>
 .col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
</style>



// WEBPACK FOOTER //
// src/views/private/apr/aprReport/aprReport.vue